import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "checkAllCheckbox", "removeVehiclesForm", "removeVehiclesButton"];

  connect() {
    document.addEventListener(
      "turbo:before-stream-render",
      this.handleTurboStreamBeforeRender.bind(this)
    );
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-stream-render",
      this.handleTurboStreamBeforeRender.bind(this)
    );
  }

  handleTurboStreamBeforeRender(event) {
    if (event.target.action === "remove") {
      const targetId = event.target.target;
      if (targetId.startsWith("fleet-plan-membership-row-")) {
        const membershipId = targetId.replace("fleet-plan-membership-row-", "");
        this.#removeValueFromRemoveVehiclesForm(membershipId);

        // after the stream is rendered, check if we need to disable the button
        // using setTimeout to ensure this runs after the DOM is updated
        setTimeout(() => {
          const hiddenInputs = this.removeVehiclesFormTarget.querySelectorAll(
            'input[name="fleet_plan_membership_ids[]"]'
          );
          this.removeVehiclesButtonTarget.disabled = hiddenInputs.length === 0;
        }, 0);
      }
    }
  }

  toggleAllCheckboxes(event) {
    const element = event.target;
    const isChecked = element.checked;

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;

      const value = checkbox.value;

      if (isChecked) {
        this.removeVehiclesButtonTarget.disabled = false;
        this.#addValueToRemoveVehiclesForm(value);
      } else {
        this.removeVehiclesButtonTarget.disabled = true;
        this.#removeValueFromRemoveVehiclesForm(value);
      }
    });
  }

  toggleCheckbox(event) {
    const element = event.target;
    const isChecked = element.checked;

    const value = element.value;

    if (isChecked) {
      this.checkAllCheckboxTarget.checked = this.checkboxTargets.every(
        (checkbox) => checkbox.checked
      );

      this.removeVehiclesButtonTarget.disabled = false;
      this.#addValueToRemoveVehiclesForm(value);
    } else {
      // Disable the remove cars button if no checkboxes are checked
      this.removeVehiclesButtonTarget.disabled = this.checkboxTargets.every(
        (checkbox) => !checkbox.checked
      );
      this.checkAllCheckboxTarget.checked = false;
      this.#removeValueFromRemoveVehiclesForm(value);
    }
  }

  #addValueToRemoveVehiclesForm(value) {
    const existingInput = this.removeVehiclesFormTarget.querySelector(`input[value="${value}"]`);

    if (existingInput) {
      return;
    }

    const input = document.createElement("input");

    input.type = "hidden";
    input.name = "fleet_plan_membership_ids[]";
    input.value = value;

    this.removeVehiclesFormTarget.appendChild(input);
  }

  #removeValueFromRemoveVehiclesForm(value) {
    const input = this.removeVehiclesFormTarget.querySelector(`input[value="${value}"]`);
    if (input) {
      this.removeVehiclesFormTarget.removeChild(input);
    }
  }
}
